import {enumValues, Sprite} from '@glark-newco/game-library';
import {Box, Button, ScrollArea, Stack, Text} from '@mantine/core';
import {IconCancel} from '@tabler/icons-react';
import styles from './CustomiseAvatar.module.css';
import {AvatarInterface, AvatarOptions, categories, resolveOption} from '../hooks/useCreateAvatar';

const readableCategory: {[key in AvatarOptions]: string} = {
    BaseType: 'Body', 
    ShirtColor: 'Shirt', 
    TieColor: 'Tie', 
    Overgarment: 'Overgarment', 
    Accessories: 'Accessories', 
    Hats: 'Hats',
};

interface CustomiseAvatarOptionsProps {
    handleChange: (property: AvatarOptions, value: number) => void
    category: AvatarOptions,
    selected: number,
}

function CustomiseAvatarOptions({handleChange, category, selected}: CustomiseAvatarOptionsProps) {
    return (
        <Box className={styles.optionsContainer}>
            {(enumValues(categories[category]) as number[]).map((optionNo: number) => {
                const option = categories[category][optionNo];
                const base = category === 'BaseType' ? optionNo : 2; // Default base for displayed options is 2
                const resolved = !optionNo ? undefined : resolveOption(base, category, optionNo); // resolve false means 'none' option
                return <Button
                    className={styles.optionButton + ' ' + (selected === optionNo ? styles.selected : '')}
                    data-testid={`option-${category}-${option}`}
                    key={option}
                    onClick={() => handleChange(category, categories[category][option] as number)}
                >
                    {resolved
                        ? <Box style={{maxWidth: '100%'}}><Sprite sprite={resolved}/></Box>
                        : <IconCancel style={{width:'100%', height: '100%', padding: '20%'}}/>
                    }
                </Button>;
            })}
        </Box>
    );
}

interface CustomiseAvatarProps {
    handleChange: (property: AvatarOptions, value: number) => void,
    avatar: AvatarInterface,
}

export function CustomiseAvatar({handleChange, avatar}: CustomiseAvatarProps) {
    return (
        <Box className={styles.mainContainer}>    
            <ScrollArea scrollbars="y" h={'100%'} type={'auto'}>
                <Stack gap={'xl'} className={styles.inner}>
                    {Object.keys(categories).map(category => {
                        return (
                            <Box key={category}>
                                {/* Header */}
                                <Box className={styles.categoryHeaderContainer}>
                                    <Text className={styles.categoryHeaderText}>
                                        {readableCategory[category as AvatarOptions]}
                                    </Text>
                                </Box>
                                {/* Options */}
                                <CustomiseAvatarOptions
                                    handleChange={handleChange}
                                    category={category as AvatarOptions}
                                    selected={avatar[category as AvatarOptions]}
                                />
                            </Box>
                        );
                    })}
                </Stack>
            </ScrollArea>
        </Box>
    );
}
